import LisioTranslationController from "../../controllers/lisio-translation-controller";
import { Lisio } from "../../lisio";

function lisioTranslationLanguageChangeMessageHandler(
  this: Lisio,
  datas: string,
) {
  const { flagIso } = JSON.parse(datas) as { flagIso: string };
  LisioTranslationController.current.loadTranslationFile(flagIso).then(() => {
    window.dispatchEvent(
      new CustomEvent("lisio-lang-change", { detail: { flagIso } }),
    );
  });
}

export { lisioTranslationLanguageChangeMessageHandler };
